import script from "./MobileLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileLayout.vue?vue&type=script&setup=true&lang=ts"

import "./MobileLayout.vue?vue&type=style&index=0&id=5989dc4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5989dc4c"]])

export default __exports__